import { FC } from 'react'
import { SvgProps } from './svgProps'

const RecommendedIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 26}
    height={height || 26}
    viewBox="0 0 26 26"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            d="M0 0H25V25H0z"
            transform="translate(-222 -109) translate(222 109)"
          />
          <g stroke={color || '#000'} strokeLinecap="round" strokeWidth="2">
            <path
              d="M14.167 21.25H5.04c-1.466 0-2.718-1.06-2.959-2.507l-1.5-9c-.272-1.634.832-3.18 2.466-3.452.163-.027.328-.041.493-.041h16.095c1.657 0 3 1.343 3 3 0 .208-.022.415-.064.618l-.905 4.299h0"
              transform="translate(-222 -109) translate(222 109) translate(.833 .417)"
            />
            <path
              d="M5 6.25l5.299-4.968c.77-.72 1.966-.72 2.736 0l5.298 4.968h0"
              transform="translate(-222 -109) translate(222 109) translate(.833 .417)"
            />
            <g>
              <path
                d="M5.833 1.387L5.152.78C3.819-.409 1.839-.217.728 1.21c-1.11 1.427-.93 3.547.402 4.736L5.5 9.843c.19.17.477.17.666 0l4.37-3.898h0c1.333-1.189 1.513-3.309.403-4.735C9.828-.217 7.847-.41 6.515.78l-.682.607z"
                transform="translate(-222 -109) translate(222 109) translate(.833 .417) translate(11.667 13.75)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default RecommendedIcon
